<template>
  <div>
    <v-row dense>
      <v-col dense cols="3">
        <v-text-field
          v-bind:label="$t('LoginSuffix')"
          v-model="loginSuffix"
          @input="defaultAdminCredentials"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-card outlined>
      <v-card-subtitle>{{ $t("Administrator") }}</v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              v-model="wizard.users[0].login"
              v-bind:label="$t('Login')"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="wizard.users[0].password"
              v-bind:label="$t('Password')"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="wizard.users[0].name"
              v-bind:label="$t('FirstName')"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="wizard.users[0].surname"
              v-bind:label="$t('Surname')"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="wizard.users[0].email"
              v-bind:label="$t('Email')"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="adminRole"
              readonly
              v-bind:label="$t('Role')"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-row
      justify="center"
      align="center"
      class="pt-5"
      v-if="users.length == 0"
    >
      <div class="text-center">
        <v-btn small @click="add" color="primary">
          {{ $t("Add") }}
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>
    </v-row>
    <v-row v-for="(user, index) in users" :key="index">
      <v-col>
        <v-text-field
          v-model="user.name"
          v-bind:label="$t('FirstName')"
          @input="defaultLogin(index)"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-model="user.surname"
          v-bind:label="$t('Surname')"
          @input="defaultLogin(index)"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-model="user.login"
          v-bind:label="$t('Login')"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-model="user.password"
          v-bind:label="$t('Password')"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-model="user.email"
          v-bind:label="$t('Email')"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-select
          multiple
          v-bind:label="$t('Roles')"
          item-text="name"
          item-value="name"
          v-model="user.roles"
          :items="wizard.roles"
        ></v-select>
      </v-col>
      <v-col align-self="center" cols="1">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" color="error" icon @click="remove(index)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Delete") }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              color="success"
              icon
              @click="add"
              v-if="showAdd(index)"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Add") }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import User from "@/ecm/models/UserImport";
export default {
  props: {
    wizard: {
      type: Object,
      default: () => ({}),
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return { loginSuffix: "" };
  },
  computed: {
    users() {
      return this.wizard.users.length == 1 ? [] : this.wizard.users.slice(1);
    },
    adminRole() {
      this.wizard.users[0].roles[0] = this.wizard.roles[0].name;
      return this.wizard.users[0].roles[0];
    },
    orgName() {
      return this.wizard.organization.name;
    },
  },
  watch: {
    orgName: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loginSuffix = val.toLowerCase().replace(/ /g, "");
          this.defaultAdminCredentials();
        }
      },
    },
  },
  methods: {
    defaultAdminCredentials() {
      var defaultCredentials = `admin.${this.loginSuffix}`;
      this.wizard.users[0].login = defaultCredentials;
      this.wizard.users[0].password = defaultCredentials;
    },
    defaultLogin(index) {
      var name = this.wizard.users[index + 1].name
        .replace(/[^a-zA-Z]+/g, "")
        .trim()
        .toLowerCase();

      var surname = this.wizard.users[index + 1].surname
        .replace(/[^a-zA-Z]+/g, "")
        .trim()
        .toLowerCase();

      var defaultCredentials = `${name[0]}${surname}.${this.loginSuffix}`;
      this.wizard.users[index + 1].login = defaultCredentials;
      this.wizard.users[index + 1].password = defaultCredentials;
    },
    remove(index) {
      this.wizard.users.splice(index + 1, 1);
    },
    add() {
      this.wizard.users.push(new User());
    },
    showAdd(index) {
      return index == this.users.length - 1;
    },
  },
};
</script>

<style>
</style>